export const PHONE_MASK = '+7 ___ ___-__-__';
export const FTTB_MASK = '___-___-____';
export const EMAIL_REGEXP = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
export const MINIMAL_PAYMENT_SUM = 100;
export const NOT_DIGIT = /\D/g;

export const SCREEN_SIZES = {
  MOBILE: 767,
  TABLET: 1024,
};

export const BUTTON_CAPTION = {
  BACK: 'Назад',
  READY: 'Готово',
  SAVE: 'Сохранить',
  DOWNLOAD: 'Скачать',
  SEND_ON_EMAIL: 'Отправить',
  RELOAD: 'Отправить код повторно',
  EDIT: 'Редактировать',
  SPECIFY: 'Указать',
  CANCEL_SENDING: 'Отменить отправку',
  RENEW_SUBSCRIPTION: 'Продлить подписку',
  SET_REGULAR_DETALIZATION_REPORT: 'Настроить регулярную отчетность',
};

export const INPUT_ERRORS = {
  PASS_CODE: 'Введите код',
  EMAIL: 'Введите корректный email',
};

export const COMMON_ERRORS = {
  WENT_WRONG: 'Ой! Что-то пошло не так',
  NO_EMAIL_ADDRESS: 'Не указан почтовый адрес',
  INCORRECT_CONFIRMATION_CODE: 'Введите корректный код',
};

export const API_DATE_FORMAT = 'YYYY-MM-DD';
